import type { FormItemResponseDTO } from '@/api/base/DTOs';
import type { FormFieldDeclaration } from '@/forms/typings';

/**
 * Pulls the declaration off a field. Narrows internally because `declaration`
 * lives on the field DTO, not on the shared item base.
 */
export const adaptFormFieldDeclarationResponse = (
  item: FormItemResponseDTO,
): FormFieldDeclaration | undefined => {
  if (!('declaration' in item) || !item.declaration) return undefined;

  return {
    message: item.declaration.message,
    showWhenBoolEquals: item.declaration.showWhenBoolEquals,
  };
};
